import React, { useEffect } from 'react';

// --- CSS STYLES FOR THE NEW DESIGN ---
// Embedded in the file for easy portability, following the requested pattern.
const styles = `
  .destinations-grid-section {
    padding: 5rem 0;
    background-color: #ffffff; /* A clean white background */
    font-family: 'Poppins', sans-serif; /* A modern, clean font */
  }

  /* --- Grid Container --- */
  .destinations-grid {
    display: grid;
    /* Creates a responsive grid that fits as many 300px columns as possible */
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-auto-rows: 280px; /* Sets a consistent height for the rows */
    gap: 1.5rem; /* Space between grid items */
    margin-top: 3rem;
  }

  /* --- Individual Grid Card Styles --- */
  .grid-card {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    background-size: cover;
    background-position: center;
    transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  }

  .grid-card:hover {
    transform: scale(1.04); /* Subtle zoom effect on hover */
    box-shadow: 0 12px 25px rgba(0,0,0,0.15);
  }

  /* --- Hover Overlay --- */
  .grid-card .content-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(10, 20, 30, 0.85); /* Dark, semi-transparent overlay */
    color: white;
    
    /* Center content using flexbox */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    
    padding: 1.5rem;
    
    opacity: 0; /* Hidden by default */
    transition: opacity 0.4s ease-in-out;
  }

  .grid-card:hover .content-overlay {
    opacity: 1; /* Revealed on hover */
  }

  .content-overlay .title {
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    transform: translateY(10px);
    transition: transform 0.4s 0.1s ease; /* Delayed slide-in effect */
  }

  .content-overlay .description {
    font-size: 0.95rem;
    margin-bottom: 1.5rem;
    opacity: 0.9;
    transform: translateY(10px);
    transition: transform 0.4s 0.2s ease; /* More delayed slide-in */
  }

  .grid-card:hover .title,
  .grid-card:hover .description {
    transform: translateY(0); /* Animate text into position */
  }

  .content-overlay .cta-button {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 0.6rem 1.5rem;
    font-weight: 500;
    text-decoration: none;
    transition: background-color 0.3s ease;
  }

  .content-overlay .cta-button:hover {
    background-color: #0056b3;
  }

  /* --- Asymmetrical Styling --- */
  /* This class makes a card span two rows, making it taller */
  .card-tall {
    grid-row: span 2;
  }
`;

// --- The Card Component for the Grid ---
const GridCard = ({ image, name, description, className = '' }) => (
  <div className={`grid-card ${className}`} style={{ backgroundImage: `url(${image})` }}>
    <div className="content-overlay">
      <h3 className="title">{name}</h3>
      <p className="description">{description}</p>
      <a href="#" className="cta-button">Explore</a>
    </div>
  </div>
);

// --- The Main Section Component ---
const Destinations2 = () => {
  // Static data for the destinations, including descriptions.
  const destinations = [
    { image: 'https://images.pexels.com/photos/3601425/pexels-photo-3601425.jpeg', name: 'Maldives', description: 'Sun-kissed beaches and turquoise waters.' },
    { image: 'https://images.pexels.com/photos/213399/pexels-photo-213399.jpeg', name: 'Bora Bora', description: 'Overwater bungalows in a tropical paradise.' },
    { image: 'https://images.pexels.com/photos/1450360/pexels-photo-1450360.jpeg', name: 'Amalfi Coast', description: 'Clifftop villages and sparkling seas.' },
    { image: 'https://images.pexels.com/photos/417074/pexels-photo-417074.jpeg', name: 'Canadian Rockies', description: 'Majestic peaks and pristine glacial lakes.' },
    { image: 'https://images.pexels.com/photos/1020016/pexels-photo-1020016.jpeg', name: 'Marrakech', description: 'Vibrant markets and rich cultural history.' },
  ];

  // Effect to inject the styles into the document head, same as the reference.
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = styles;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <section className="destinations-grid-section">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-4">
          <h2 className="display-4 fw-bold">Unforgettable Journeys</h2>
          <p className="lead text-secondary">Discover destinations that will inspire you.</p>
        </div>
        
        {/* The Grid */}
        <div className="destinations-grid">
          {/* We manually assign the 'card-tall' class to the first item for the design */}
          <GridCard {...destinations[0]} className="card-tall" />
          <GridCard {...destinations[1]} />
          <GridCard {...destinations[2]} />
          <GridCard {...destinations[3]} />
          <GridCard {...destinations[4]} />
        </div>
      </div>
    </section>
  );
};

export default Destinations2;